import { render, staticRenderFns } from "./CourseSidebar.vue?vue&type=template&id=3aa79f26&scoped=true"
import script from "./CourseSidebar.vue?vue&type=script&lang=js"
export * from "./CourseSidebar.vue?vue&type=script&lang=js"
import style0 from "./CourseSidebar.vue?vue&type=style&index=0&id=3aa79f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa79f26",
  null
  
)

export default component.exports